<template>
  <div class="container-fluid login-wrapper">
    <div class="row min-vh-100">

      <!-- LADO IZQUIERDO / BRANDING -->
      <div class="col-lg-6 d-none d-lg-flex login-left">
        <div class="login-left-content">

          <h1 class="headline">
            <span class="headline-line">Tus CFDIs organizados</span>
            <span class="headline-line">claros y bajo control</span>
          </h1>
          <br>
          <br>
          <br>
          <p class="subtitle">
            Automatiza la descarga desde el SAT y convierte tus facturas en 
            información útil para tomar mejores decisiones.
          </p>
          <p class="subtitle">
            Más que software fiscal, una herramienta para crecer con orden.
          </p>

          <div class="stats">
            <div class="stat">
              <h3>+500k</h3>
              <span>CFDIs gestionados</span>
            </div>

            <div class="stat-divider"></div>

            <div class="stat">
              <h3>99.9%</h3>
              <span>Disponibilidad SAT</span>
            </div>
          </div>

        </div>
      </div>


      <!-- LADO DERECHO / LOGIN -->
      <div class="col-lg-6 col-12 d-flex align-items-center justify-content-center">
        <div class="login-card-modern">

          <!-- LOGO -->
          <div class="brand text-center mb-4">
            <img src="../assets/images/logo/logo.png" alt="TusCFDIs" width="150" />
          </div>

          <h2 class="title text-center">Bienvenido</h2>
          <p class="text-muted text-center mb-5">
            Ingresa a tu cuenta para continuar
          </p>

          <form class="theme-form" @submit.prevent="login">
            <div v-if="formError" class="alert alert-danger" role="alert">{{ formError }}</div>

            <!-- EMAIL -->
            <div class="form-group mb-4">
              <label>Correo electrónico</label>
              <input type="email" class="form-control form-control-lg" placeholder="nombre@empresa.com"
                v-model="form.email" @input="normalizeEmail" @blur="v$.form.email.$touch()" :class="{ 'is-invalid': v$.form.email.$error }" />
              <div class="invalid-feedback d-block" v-if="v$.form.email.$error">
                {{ v$.form.email.$errors[0].$message }}
              </div>
            </div>

            <!-- PASSWORD -->
            <div class="form-group mb-4">
              <div class="d-flex justify-content-between">
                <label>Contraseña</label>
                <router-link v-if="showRecoverPasswordOption()" class="link" :to="{ name: 'recoverPassword' }">
                  ¿Olvidaste tu contraseña?
                </router-link>
              </div>

              <div class="position-relative">
                <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg pe-5"
                  placeholder="••••••••" v-model="form.password" @blur="v$.form.password.$touch()"
                  :class="{ 'is-invalid': v$.form.password.$error }" />
                <span class="toggle-password" @click="showPassword = !showPassword">
                  👁
                </span>
              </div>

              <div class="invalid-feedback d-block" v-if="v$.form.password.$error">
                {{ v$.form.password.$errors[0].$message }}
              </div>
            </div>

            <button class="btn btn-primary btn-lg w-100 mt-2">
              Iniciar sesión
            </button>

          </form>


          <!-- DIVIDER -->
          <div v-if="showSocialLogin()" class="divider my-4">
            <span>O ENTRAR CON</span>
          </div>

          <!-- GOOGLE -->
          <button v-if="showSocialLogin()" type="button" class="btn btn-light btn-lg w-100 google-btn" @click="startGoogleAuth">
            <img src="../assets/images/svg-icon/google.svg" alt="Google" />
            <span>Google</span>
          </button>

          <button v-if="showSocialLogin() && isFacebookLoginEnabled()" type="button" class="btn btn-lg w-100 facebook-btn mt-3" @click="startFacebookAuth">
            <i class="fa fa-facebook"></i>
            <span>Facebook</span>
          </button>

          <!-- REGISTER -->
          <p v-if="showRegisterOption()" class="text-center mt-4">
            ¿No tienes una cuenta?
            <router-link :to="{ name: 'register' }">
              Regístrate ahora
            </router-link>
          </p>

          <div class="footer-divider"></div>

          <!-- FOOTER -->
          <div class="auth-footer text-center mt-5">
            <div class="links">
              <a target="_blank" href="https://tuscfdis.com/terminos">Términos</a>
              <a target="_blank" href="https://tuscfdis.com/politica-privacidad">Privacidad</a>
            </div>
            <small class="d-block mt-3">
              © 2026 TusCFDIs México
            </small>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ws from '@/services/login';
import { normalizeEmail } from '@/mixins/normalizers';
import { setGlobalPeriod } from '@/services/globalPeriod';
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import moment from 'moment';

export default {
  name: 'login',

  data() {
    return {
      showPassword: false,
      formError: '',
      form: {
        email: '',
        password: ''
      }
    }
  },

  validations() {
    return {
      form: {
        email: {
          required: helpers.withMessage('Ingresa tu correo electrónico', required),
          email: helpers.withMessage('Ingresa un correo válido', email)
        },
        password: {
          required: helpers.withMessage('Ingresa tu contraseña', required)
        }
      }
    }
  },

  setup() {
    return { v$: useVuelidate() }
  },

  mounted() {
    this.applyDemoDefaults()
    this.processOAuthFromHash()
  },

  methods: {
    isDemoEnvironment() {
      const host = String(window.location.hostname || '').trim().toLowerCase()
      const appEnv = String(process.env.VUE_APP_ENV || '').trim().toLowerCase()

      return host === 'demo.tuscfdis.com' || appEnv === 'demo'
    },
    showSocialLogin() {
      return !this.isDemoEnvironment()
    },
    showRegisterOption() {
      return !this.isDemoEnvironment()
    },
    showRecoverPasswordOption() {
      return !this.isDemoEnvironment()
    },
    applyDemoDefaults() {
      if (!this.isDemoEnvironment()) {
        return
      }

      this.form.email = 'demo@tuscfdis.com'
      this.form.password = 'Demo#123'
    },
    getGoogleClientId() {
      return String(process.env.VUE_APP_GOOGLE_CLIENT_ID || '').trim()
    },
    getFacebookAppId() {
      return String(process.env.VUE_APP_FACEBOOK_APP_ID || '').trim()
    },
    isFacebookLoginEnabled() {
      const value = String(process.env.VUE_APP_ENABLE_FACEBOOK_LOGIN || '').trim().toLowerCase()
      return value === '1' || value === 'true' || value === 'yes'
    },
    getFacebookRedirectUri() {
      const configuredRedirect = String(process.env.VUE_APP_FACEBOOK_REDIRECT_URI || '').trim()
      if (configuredRedirect) {
        return configuredRedirect
      }

      return 'https://app.tuscfdis.com/login'
    },
    getOAuthStateKey(provider) {
      return `${provider}_oauth_state`
    },
    saveOAuthState(provider, state) {
      sessionStorage.setItem(this.getOAuthStateKey(provider), state)
    },
    peekOAuthState(provider) {
      return sessionStorage.getItem(this.getOAuthStateKey(provider))
    },
    consumeOAuthState(provider) {
      const key = this.getOAuthStateKey(provider)
      const expectedState = sessionStorage.getItem(key)
      sessionStorage.removeItem(key)
      return expectedState
    },
    generateOAuthState() {
      return Math.random().toString(36).slice(2) + Date.now().toString(36)
    },
    async processOAuthFromHash() {
      this.formError = ''
      const hash = String(window.location.hash || '')
      if (!hash.startsWith('#')) return

      const params = new URLSearchParams(hash.slice(1))
      const idToken = params.get('id_token')
      const accessToken = params.get('access_token')
      const state = params.get('state')
      const error = params.get('error')
      const facebookEnabled = this.isFacebookLoginEnabled()
      const hasGoogleState = state && state === this.peekOAuthState('google')
      const hasFacebookState = facebookEnabled && state && state === this.peekOAuthState('facebook')

      if (!idToken && !accessToken && !error) return

      if (!idToken && !accessToken && error && !hasGoogleState && !hasFacebookState) return

      window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`)

      if (idToken || hasGoogleState) {
        await this.processGoogleAuthFromHash({ idToken, state, error })
        return
      }

      if (facebookEnabled && (accessToken || hasFacebookState)) {
        await this.processFacebookAuthFromHash({ accessToken, state, error })
      }
    },
    async processGoogleAuthFromHash({ idToken, state, error }) {
      if (!idToken && !error) return

      if (error) {
        this.formError = 'No fue posible autenticar con Google'
        return
      }

      const expectedState = this.consumeOAuthState('google')

      if (!expectedState || state !== expectedState) {
        this.formError = 'La sesión de Google no es válida, intenta nuevamente'
        return
      }

      await this.loginWithGoogleIdToken(idToken)
    },
    async processFacebookAuthFromHash({ accessToken, state, error }) {
      if (!accessToken && !error) return

      if (error) {
        this.formError = 'No fue posible autenticar con Facebook'
        return
      }

      const expectedState = this.consumeOAuthState('facebook')

      if (!expectedState || state !== expectedState) {
        this.formError = 'La sesión de Facebook no es válida, intenta nuevamente'
        return
      }

      await this.loginWithFacebookAccessToken(accessToken)
    },
    startGoogleAuth() {
      this.formError = ''
      const clientId = this.getGoogleClientId()
      if (!clientId) {
        this.formError = 'Google OAuth no está configurado. Falta VUE_APP_GOOGLE_CLIENT_ID'
        return
      }

      const state = this.generateOAuthState()
      const nonce = this.generateOAuthState()
      const redirectUri = `${window.location.origin}${window.location.pathname}`

      this.saveOAuthState('google', state)

      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth')
      authUrl.searchParams.set('client_id', clientId)
      authUrl.searchParams.set('redirect_uri', redirectUri)
      authUrl.searchParams.set('response_type', 'id_token')
      authUrl.searchParams.set('scope', 'openid email profile')
      authUrl.searchParams.set('prompt', 'select_account')
      authUrl.searchParams.set('nonce', nonce)
      authUrl.searchParams.set('state', state)

      window.location.assign(authUrl.toString())
    },
    startFacebookAuth() {
      if (!this.isFacebookLoginEnabled()) {
        return
      }

      this.formError = ''
      const appId = this.getFacebookAppId()
      if (!appId) {
        this.formError = 'Facebook OAuth no está configurado. Falta VUE_APP_FACEBOOK_APP_ID'
        return
      }

      const state = this.generateOAuthState()
      const redirectUri = this.getFacebookRedirectUri()

      this.saveOAuthState('facebook', state)

      const authUrl = new URL('https://www.facebook.com/v20.0/dialog/oauth')
      authUrl.searchParams.set('client_id', appId)
      authUrl.searchParams.set('redirect_uri', redirectUri)
      authUrl.searchParams.set('response_type', 'token')
      authUrl.searchParams.set('scope', 'email')
      authUrl.searchParams.set('state', state)

      window.location.assign(authUrl.toString())
    },
    applySession(data) {
      const token = data.token
      const user = data.user
      const currentPeriod = moment().format('YYYY-MM')

      localStorage.setItem('access_token', token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('rfcs', JSON.stringify(user.rfcs || []))
      localStorage.setItem('period', currentPeriod)
      setGlobalPeriod(currentPeriod)

      if (user.rfc) {
        localStorage.setItem('rfc', user.rfc.rfc)
        localStorage.setItem('fiscal_name', user.rfc.name)
        this.$router.push({ name: 'dashboard' })
      } else {
        localStorage.setItem('rfc', "")
        localStorage.setItem('fiscal_name', "")
        this.$router.push({ name: 'settings', query: { section: 'rfcs' } })
      }
    },
    async loginWithGoogleIdToken(idToken) {
      this.formError = ''
      this.$loading.show()

      try {
        const response = await ws.loginGoogle(idToken)

        if (response.type !== "success") {
          this.formError = response.message
          return
        }

        this.applySession(response.data)
      } catch (e) {
        this.formError = 'Error al iniciar sesión con Google'
      } finally {
        this.$loading.hide()
      }
    },
    async loginWithFacebookAccessToken(accessToken) {
      this.formError = ''
      this.$loading.show()

      try {
        const response = await ws.loginFacebook(accessToken)

        if (response.type !== "success") {
          this.formError = response.message
          return
        }

        this.applySession(response.data)
      } catch (e) {
        this.formError = 'Error al iniciar sesión con Facebook'
      } finally {
        this.$loading.hide()
      }
    },
    normalizeEmail() {
      this.form.email = normalizeEmail(this.form.email)
    },
    async login() {
      this.formError = ''
      this.normalizeEmail()

      this.v$.$touch()
      if (this.v$.$invalid) return

      this.$loading.show()

      try {
        const email = normalizeEmail(this.form.email)
        const response = await ws.login(email, this.form.password)

        if (response.type !== "success") {
          this.formError = response.message
          return
        }

        this.applySession(response.data)

      } catch (e) {
        this.formError = 'Error al iniciar sesión'
      } finally {
        this.$loading.hide()
      }
    }
  }
}

</script>
